export default {
  MoserIcon: {
    display: 'inline-block',
    background: {
      size: 'cover',
    },
  },
};
